const regex = new RegExp('[^0-9-,]', 'g');

export const parseUnformattedNum = (unformatted: string) => {
  unformatted = unformatted.replace(regex, '').replace(',', '.');
  return parseFloat(unformatted);
};
